<template>
    <v-card class="my-2 tour-card" variant="outlined">
        <div>
            <v-img
                tile
                :src="$filters.imageUrl(mainImg, 200)"
                :alt="offer.info.name"
                height="200"
                lazy-src="/placeholder.png"
                eager
                @error="onImgError"
            >
                <template v-slot:placeholder>
                    <v-row
                        v-show="!imgError && offer.mainImageUrl"
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                    >
                        <v-progress-circular indeterminate color="grey-lighten-5" />
                    </v-row>
                </template>
            </v-img>
            <div class="ma-2 flex-grow-1 flex-shrink-1 d-flex flex-column justify-space-between">
                <div>
                    <div class="mb-2 font-weight-medium text-truncate text-primary">
                        <nuxt-link
                            v-if="$route.name === 'tourSearch'"
                            :to="{name: 'tour', query}"
                            no-prefetch
                            class="text-decoration-none"
                        >
                            {{ offer.info.name }}
                        </nuxt-link>
                        <span v-else>
                            {{ offer.info.name }}
                        </span>
                    </div>
                    <tour-included-entries :entries="offer.entries" class="mb-1" />
                    <div class="mb-3 d-flex align-center">
                        <span class="mr-4 font-weight-medium">
                            <v-icon color="blue">mdi-clock-outline</v-icon>
                            {{
                                `${offer.info.packageDuration} ${$t('day', offer.info.packageDuration)} / ${
                                    offer.info.nightsDuration
                                } ${$t('night', offer.info.nightsDuration)}`
                            }}
                        </span>
                    </div>
                    <div v-if="offer.info.description" class="mb-3 tour-description" v-html="offer.info.description" />
                    <v-divider class="mb-3" />
                    <div class="mb-1 d-flex">
                        <tour-available-date-label :offers="offers" :selected-date="selectedDate" />
                        <tour-date-filter
                            v-if="groupType === 'tourName' && packageDates.length > 1"
                            v-model="selectedDate"
                            :offers="offers"
                        />
                    </div>
                </div>
            </div>
            <div class="ma-4 price-col flex-shrink-0 text-right">
                <div data-cy="client-price" class="font-weight-medium">
                    {{ $filters.price(totalPrice) }}
                </div>
                <discount-label :price="offer.price" />
                <div class="text-caption text--secondary">
                    {{
                        `${$t('for')} ${touristsTotal} ${$t('guest', touristsTotal)}, ${offer.info.nightsDuration}
                            ${$t('night', offer.info.nightsDuration)}`
                    }}
                </div>
                <v-btn variant="flat" block color="primary" class="my-2" :to="{name: 'tour', query}">
                    {{ $t('select') }}
                </v-btn>
                <div class="text-primary cursor-pointer text-no-wrap" @click="expanded = !expanded">
                    <span>
                        {{ $t('tours.detailed_info') }}
                    </span>
                    <v-icon color="primary">
                        {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                </div>
                <div
                    v-if="offers?.length > 1"
                    class="text-primary cursor-pointer text-no-wrap"
                    @click="isExpandOffers = !isExpandOffers"
                >
                    <span>
                        {{ $t('view_offers') }}
                    </span>
                    <v-icon color="primary">
                        {{ isExpandOffers ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                </div>
            </div>
        </div>
        <v-expand-transition>
            <tour-offer-entries-list v-if="expanded" class="pa-4" :offer="offer" />
        </v-expand-transition>
        <v-expand-transition>
            <div v-if="isExpandOffers">
                <TourOfferSubCard
                    v-for="offer in expandedOffers"
                    :key="offer.id"
                    :offer="offer"
                    :offer-data="offer.info.packageDate"
                    :offer-tariff="offer.info.offerInfo.tariffName"
                    :title="offer.info?.serviceName || offer.info?.name"
                    :secondary-service-name="offer.info?.secondaryServiceName"
                    :search-request="searchRequest"
                    @select="selectForBooking"
                />
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {TourOfferCard} from '@/components/tours/search/offers/TourOfferCard.vue'
    import TourOfferSubCard from '~/components/tours/search/offers/TourOfferSubCard.vue'

    @Component({
        components: {
            TourOfferSubCard,
        },
    })
    export class TourOfferCardMobile extends TourOfferCard {}

    export default TourOfferCardMobile
</script>

<style lang="scss" scoped>
    .tour-card {
        border: none !important;
    }

    :deep(.tour-description p) {
        margin-bottom: 0;
    }
</style>
